<template>
    <!-- Navegación de "Mi cuenta" en el lateral (abajo). Reemplaza a la barra
         de pestañas que estaba debajo del header (NavMenu.vue). Realizadas /
         Recibidas se eligen con las pestañas de la lista de reservas. -->
    <nav class="bk-snav" :aria-label="$t('nuevo_menu.nav.account')">
        <p class="bk-snav-title">{{ $t('nuevo_menu.nav.account') }}</p>
        <ul class="bk-snav-list">
            <li v-for="item in items" :key="item.to">
                <router-link
                    :to="item.to"
                    :class="['bk-snav-link', { 'is-active': item.activo }]"
                    :aria-current="item.activo ? 'page' : null"
                >
                    <span v-html="item.icono"></span>
                    <span>{{ $t(item.texto) }}</span>
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import ICON from './iconos';

export default {
    name: 'CuentaNav',
    computed: {
        ...mapGetters(['isProperty']),
        items() {
            const ruta = this.$route.path;
            const lista = [
                { to: '/editar-perfil', icono: ICON.user, texto: 'nuevo_menu.nav.profile' },
                { to: '/cambiar-password', icono: ICON.lock, texto: 'nuevo_menu.nav.password' },
            ];
            // El usuario "property" tiene la cuenta recortada (sin datos
            // bancarios ni reservas), como en el menú anterior.
            if (!this.isProperty) {
                lista.push({ to: '/datos-bancarios', icono: ICON.bank, texto: 'nuevo_menu.nav.bank' });
                lista.push({ to: '/reservations-made', icono: ICON.cal, texto: 'nuevo_menu.nav.reservations', grupo: ['/reservations-made', '/reservations-received'] });
            }
            return lista.map(i => ({ ...i, activo: (i.grupo || [i.to]).includes(ruta) }));
        },
    },
};
</script>

<style>
/* Las <span> con el ícono no agregan caja propia. */
.bk-snav-link > span:first-child { display: contents; }
</style>
